import { useEffect, useState } from 'react'

import { Stack } from '@mui/material'
import ToggleField from './ToggleField'

const PasswordField = ({
  label = 'Password',
  name = 'password',
  value,
  onChange,
  error,
  helperText,
  slotProps,
  confirmation,
  ...rest
}) => {
  const [confirmValue, setConfirmValue] = useState('')

  const hasTypedConfirmValue = confirmValue !== ''
  const passwordsMatch = hasTypedConfirmValue && confirmValue === value
  const showMismatch = hasTypedConfirmValue && !passwordsMatch

  const onMatchChange = confirmation?.onMatchChange
  useEffect(() => {
    onMatchChange?.(passwordsMatch)
  }, [passwordsMatch, onMatchChange])

  const mainField = (
    <ToggleField
      {...rest}
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      slotProps={slotProps}
    />
  )

  if (!confirmation) {
    return mainField
  }

  const confirmLabel =
    confirmation.label || (label ? `Confirm ${label}` : 'Confirm password')
  const mismatchMessage =
    confirmation.mismatchMessage || 'Passwords do not match'

  const onConfirmChange = (e) => {
    const newValue = e.target.value
    setConfirmValue(newValue)
    confirmation.onValueChange?.(newValue)
  }

  return (
    <Stack spacing={confirmation.spacing ?? 3}>
      {mainField}
      <ToggleField
        {...rest}
        label={confirmLabel}
        name={confirmation.name || `${name || 'password'}Confirmation`}
        value={confirmValue}
        onChange={onConfirmChange}
        error={showMismatch}
        helperText={showMismatch ? mismatchMessage : ''}
        slotProps={confirmation.slotProps || slotProps}
      />
    </Stack>
  )
}

export default PasswordField
